import { CustomProperty, CustomPropertyType } from "winslow-core";

export const getCustomPropertyForAttribute = (
  attributePath: string,
  customProperties: CustomProperty[]
): CustomProperty | null => {
  return customProperties.find((cp) => cp.label === attributePath) || null;
};

export const getPropertyChoices = (
  attributePath: string,
  customProperties: CustomProperty[]
): string[] => {
  const property = getCustomPropertyForAttribute(
    attributePath,
    customProperties
  );
  if (!property?.settings) return [];

  try {
    const settings = JSON.parse(property.settings);
    return settings.choices || [];
  } catch {
    return [];
  }
};

export const getPropertyDefault = (
  attributePath: string,
  customProperties: CustomProperty[]
): string | string[] | undefined => {
  const property = getCustomPropertyForAttribute(
    attributePath,
    customProperties
  );
  if (!property?.settings) return undefined;

  try {
    const settings = JSON.parse(property.settings);
    return settings.default;
  } catch {
    return undefined;
  }
};

export const isEditableDropdown = (
  attributePath: string,
  customProperties: CustomProperty[]
): boolean => {
  const property = getCustomPropertyForAttribute(
    attributePath,
    customProperties
  );
  if (!property?.settings) return false;

  try {
    const settings = JSON.parse(property.settings);
    return settings.editable === true;
  } catch {
    return false;
  }
};

export const parseConditionValue = (
  value: string,
  propertyType: CustomPropertyType
): any => {
  if (!value) return value;

  switch (propertyType) {
    case CustomPropertyType.NUMBER:
      return parseFloat(value);
    case CustomPropertyType.CHECKBOX_MULTIPLE:
      try {
        return JSON.parse(value);
      } catch {
        return [];
      }
    case CustomPropertyType.CHECKBOX_SINGLE:
      return value === "true";
    case CustomPropertyType.DATE:
      return value;
    default:
      return value;
  }
};

export const serializeConditionValue = (
  value: any,
  propertyType: CustomPropertyType
): string => {
  switch (propertyType) {
    case CustomPropertyType.CHECKBOX_MULTIPLE:
      return JSON.stringify(value);
    case CustomPropertyType.CHECKBOX_SINGLE:
      return String(value);
    case CustomPropertyType.NUMBER:
      return String(value);
    default:
      return String(value);
  }
};

export const getPropertySettings = (
  attributePath: string,
  customProperties: CustomProperty[]
): any => {
  const property = getCustomPropertyForAttribute(
    attributePath,
    customProperties
  );
  if (!property?.settings) return {};

  try {
    return JSON.parse(property.settings);
  } catch {
    return {};
  }
};

